<template>

  <svg
    t="1631088907443"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4647"
    width="64"
    height="64"
  ><path d="M97.74762667 926.25237333v-911.35431111h-82.85070222v911.35431111h-0.20707556v82.85070222h994.20501333v-82.85070222h-911.14837333z" p-id="4648" /><path d="M637.31143111 677.28611555l-237.88430222-209.40458666-158.76209778 199.35914666-64.83057778-51.57432888 213.13308445-267.50293334 239.33383111 210.85525334 321.45976889-384.32199112 63.48344889 53.23093334-375.93429334 449.35964444z" p-id="4649" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconChartLine',
} as DefineComponent
</script>